import {
  type OverlayGroup,
  type LayerToggleAction,
} from "../components/LayerGroupControl";
import {
  GEOSPACE_CHIBAN_TILE_LAYER_NAME,
  LEGAL_AFFAIRS_CHIBAN_TILE_LAYER_NAME,
  LEGAL_AFFAIRS_CHIBAN_MIN_ZOOM,
  LEGAL_AFFAIRS_CHIBAN_MAX_ZOOM,
} from "@/features/map/components/CommonChibanTileLayer";
import {
  AREA_USE_PURPOSE_LAYER_NAME_NATIONAL_LAND_NUMERICAL_INFORMATION,
  AREA_USE_PURPOSE_LAYER_NAME_CITY_PLANNING_DECISION_GIS_DATA,
} from "../components/AreaUsePurposeLayerControlWrapper";
import {
  NATIONAL_LAND_NUMERICAL_INFORMATION_HOST,
  CITY_PLANNING_DECISION_GIS_DATA_HOST,
  AREA_USE_PURPOSE_MIN_ZOOM,
  AREA_USE_PURPOSE_MAX_ZOOM,
} from "../components/mapLibre/layers/AreaUsePurposeTileLayer";
import { FLOOD_10_LAYER_NAME } from "../components/layers/HazardFlood10Layer";
import { FLOOD_20_LAYER_NAME } from "../components/layers/HazardFlood20Layer";
import { FLOOD_30_LAYER_NAME } from "../components/layers/HazardFlood30Layer";
import {
  LANDSLIDE_DEBRIS_FLOW_LAYER_NAME,
  LANDSLIDE_LANDSLIDE_LAYER_NAME,
  LANDSLIDE_STEEP_SLOPE_LAYER_NAME,
} from "../components/layers/HazardLandslideLayer";
import { TSUNAMI_LAYER_NAME } from "../components/layers/HazardTsunamiLayer";
import { STORM_SURGE_LAYER_NAME } from "../components/layers/HazardStormSurgeLayer";
import {
  LANDSLIDE_PREVENTION_LAYER_NAME,
  LANDSLIDE_PREVENTION_MIN_ZOOM,
  LANDSLIDE_PREVENTION_MAX_ZOOM,
} from "../components/layers/LandslidePreventionLayer";
import { LAND_PRICE_LAYER_NAME } from "@/features/map/components/LandPriceLayerControlWrapper";
import { TRADE_PRICE_LAYER_NAME } from "@/features/map/components/TradePriceLayerControlWrapper";
import { REAL_ESTATE_SEARCH_LAYER_NAME } from "../components/layers/RealEstateSearchLayer";
import { REQUESTED_PICTURES_PLOT_LAYER_NAME } from "../components/layers/RequestedPicturesPlotLayer";
import {
  IDOL_FARMLAND_LAYER_NAME,
  IDOL_FARMLAND_MIN_ZOOM,
  IDOL_FARMLAND_MAX_ZOOM,
} from "../components/layers/IdolFarmlandLayer";
import {
  FARMLAND_LAYER_LABEL,
  FARMLAND_LAYER_NAME,
  FARMLAND_MIN_ZOOM,
  FARMLAND_MAX_ZOOM,
} from "../components/layers/FarmlandLayer";
import {
  CITY_PLANNING_AREA_LAYER_NAME,
  CITY_PLANNING_AREA_MIN_ZOOM,
  CITY_PLANNING_AREA_MAX_ZOOM,
} from "../components/layers/CityPlanningAreaLayer";
import { MUNICIPAL_DOCUMENT_LAYER_NAME } from "../components/layers/MunicipalDocumentLayer";
import { SAVED_PLOT_LAYER_NAME } from "../components/layers/SavedPlotLayer";
import {
  FIRE_PROTECTION_AREA_LAYER_NAME,
  FIRE_PROTECTION_POLYGON_MIN_ZOOM,
  FIRE_PROTECTION_POLYGON_MAX_ZOOM,
} from "@/features/map/components/layers/FireProtectionAreaLayer";
import {
  HIGH_LEVEL_AREA_LAYER_NAME,
  HIGH_LEVEL_AREA_MIN_ZOOM,
  HIGH_LEVEL_AREA_MAX_ZOOM,
} from "@/features/map/components/layers/HighLevelAreaLayer";
import {
  HIGH_LEVEL_USE_AREA_LAYER_NAME,
  HIGH_LEVEL_USE_AREA_MIN_ZOOM,
  HIGH_LEVEL_USE_AREA_MAX_ZOOM,
} from "@/features/map/components/layers/HighLevelUseAreaLayer";
import {
  DISASTER_RISK_AREA_LAYER_NAME,
  DISASTER_RISK_AREA_MIN_ZOOM,
  DISASTER_RISK_AREA_MAX_ZOOM,
} from "@/features/map/components/layers/DisasterRiskAreaLayer";
import {
  ELEMENTARY_SCHOOL_AREA_LAYER_NAME,
  JUNIOR_HIGH_SCHOOL_AREA_LAYER_NAME,
  SCHOOL_AREA_MIN_ZOOM,
  SCHOOL_AREA_MAX_ZOOM,
} from "@/features/map/components/layers/SchoolAreaLayer";
import {
  ZENRIN_RESIDENTIAL_MIN_ZOOM,
  ZENRIN_RESIDENTIAL_MAX_ZOOM,
  ZENRIN_RESIDENTIAL_MAP_LAYER_NAME,
} from "../components/ZenrinTileLayer";
import {
  ZENRIN_BLUE_MAP_MIN_ZOOM,
  ZENRIN_BLUE_MAP_MAX_ZOOM,
  ZENRIN_BLUE_MAP_LAYER_NAME,
} from "../components/layers/ZenrinBlueMapTileLayer";
import {
  LAND_PRICE_MIN_ZOOM,
  LAND_PRICE_MAX_ZOOM,
} from "@/features/map/components/mapLibre/layers/LandPriceTileLayer";
import {
  TRADE_PRICE_MIN_ZOOM,
  TRADE_PRICE_MAX_ZOOM,
} from "@/features/map/components/TradePriceTileLayer";
import {
  HAZARD_BASE_MIN_ZOOM,
  HAZARD_BASE_MAX_ZOOM,
} from "../components/layers/HazardBaseLayer";
import { TRUSTART_CHIBAN_LAYER_NAME } from "@/features/map/components/layers/TrustartChibanTileLayer";
import {
  REGISTRATION_MAP_LAYER_NAME,
  REGISTRATION_MAP_SOURCE_LINK_TEXT,
  REGISTRATION_MAP_SOURCE_TEXT,
  REGISTRATION_MAP_SOURCE_URL,
} from "@/features/map/components/mapLibre/layers/RegistrationMapTileLayer";
import { CONTACT_US_URL } from "@/configs/constants";
import {
  GEOSPACE_CHIBAN_PANEL_MIN_ZOOM,
  REGISTRATION_MAP_PANEL_MIN_ZOOM,
  TRUSTART_CHIBAN_PANEL_MIN_ZOOM,
} from "./layerPanelZoom";
import {
  buildPhotoOverlayGroup,
  PHOTO_SECTION_TITLE,
} from "./photoOverlayGroup";
import {
  ROAD_LAYER_MODE_CLASS,
  ROAD_LAYER_MODE_WIDTH,
  ROAD_LAYER_NAME,
  ROAD_TILE_HOST,
} from "@/features/map/constants/roadLayer";

export const GEOSPACE_ELECTRONIC_MAP_LAYER_NAME = "GEOSPACE電子地図";
export const GEOSPACE_SECTION_TITLE = "GEOSPACE";
export const ZENRIN_SECTION_TITLE = "ゼンリン";
export const TRUSTART_SECTION_TITLE = "役所";
export { PHOTO_SECTION_TITLE };

// データレイヤーのセクションタイトル（意味的なまとまりごとに分割）
export const PROPERTY_INFO_SECTION_TITLE = "物件情報";
export const MUNICIPAL_DOCUMENT_SECTION_TITLE = "役所資料（黒塗り）";
export const PRICE_INFO_SECTION_TITLE = "価格情報";
export const CITY_PLANNING_INFO_SECTION_TITLE = "都市計画情報";
export const DISASTER_HAZARD_INFO_SECTION_TITLE = "防災・ハザード情報";
export const SURROUNDING_FACILITY_INFO_SECTION_TITLE = "周辺施設情報";
export const TRAFFIC_INFO_SECTION_TITLE = "交通情報";
export const RECEPTION_BOOK_LAYER_NAME = "受付帳情報ピンを表示";
export const ZENRIN_FETCHED_IMAGE_LAYER_NAME = "取得した住宅地図（表札あり）";

export interface GetOverlayGroupsParams {
  trustartChibanMap: boolean;
  /**
   * 登記所備付地図をパネルに出すか（フィーチャーフラグ ON かつ、利用可ならタイル公開済み）。
   * 利用できないテナントでは役所地番地図と同じくロック表示にする。
   */
  registrationMapAvailable: boolean;
  /**
   * 役所地番地図・登記所備付地図のレイヤーを利用できるテナントか
   * （暫定: MunicipalParcelMapPricing 由来）
   */
  isMunicipalParcelMapAvailable: boolean;
  isRoadLayerEnabled: boolean;
  showZenrinSection: boolean;
  canUseZenrinMap: boolean;
  showGeospaceSection: boolean;
  cdsMap: boolean;
  mapServiceAppId: string | null | undefined;
  hasReceptionBookMarkers: boolean;
  /** 保存した物件リストのピンをリストごとに色分けするか（CRM の時だけ） */
  savedPlotColorsByList?: boolean;
  /** 役所資料（黒塗り）のレイヤーを出すか（reassist-archive フラグ）。 */
  reassistArchive?: boolean;
  cityPlanningAreaUsePurposeLayer: boolean;
  idolFarmland: boolean;
  farmland: boolean;
  farmlandAction?: LayerToggleAction;
}

/**
 * 【ズーム制限値（minZoom / maxZoom）の定義方針に関する設計判断の経緯】
 * 以前はズームレベル定義を本ファイル（overlayGroups.tsx）で一元管理するアプローチ（クラス化やContext化）を
 * 試みたが、各レイヤーの実装（マップ表示・描画ライブラリ側などでのハードコード値や定数定義）との両立が
 * 著しく複雑化し保守性が低下するため、各レイヤーの実装ファイルを真のソース（Single Source of Truth）とする設計を採用した。
 * したがって、本ファイルでは各レイヤーから export された定数を import して直接割り当てる形をとる。
 *
 * @param params ランタイムの契約状態、各種フラグ、コールバックアクションを含むパラメータ
 * @returns 構築された OverlayGroup の配列
 */
export const getOverlayGroups = (
  params: GetOverlayGroupsParams
): OverlayGroup[] => {
  const {
    trustartChibanMap,
    registrationMapAvailable,
    isMunicipalParcelMapAvailable,
    isRoadLayerEnabled,
    showZenrinSection,
    canUseZenrinMap,
    showGeospaceSection,
    cdsMap,
    mapServiceAppId,
    hasReceptionBookMarkers,
    savedPlotColorsByList = false,
    reassistArchive = false,
    cityPlanningAreaUsePurposeLayer,
    idolFarmland,
    farmland,
    farmlandAction,
  } = params;

  return [
    // ゼンリンセクション（権限がある場合のみ表示）
    ...(showZenrinSection
      ? [
          {
            title: ZENRIN_SECTION_TITLE,
            layers: [
              {
                name: ZENRIN_RESIDENTIAL_MAP_LAYER_NAME,
                label: ZENRIN_RESIDENTIAL_MAP_LAYER_NAME,
                disabled: !canUseZenrinMap,
                description:
                  "表札情報を除いた、建物形状や地番等が確認できるゼンリンの住宅地図です。",
                minZoom: ZENRIN_RESIDENTIAL_MIN_ZOOM,
                maxZoom: ZENRIN_RESIDENTIAL_MAX_ZOOM,
                attributionText: "ZENRIN",
                attributionUrl: "https://www.zenrin.co.jp/",
              },
              {
                name: ZENRIN_FETCHED_IMAGE_LAYER_NAME,
                label: ZENRIN_FETCHED_IMAGE_LAYER_NAME,
                disabled: false,
                description:
                  "システム上で購入・取得した表札情報付きの住宅地図画像を表示します。",
                minZoom: ZENRIN_RESIDENTIAL_MIN_ZOOM,
                maxZoom: ZENRIN_RESIDENTIAL_MAX_ZOOM,
              },
              {
                name: ZENRIN_BLUE_MAP_LAYER_NAME,
                label: ZENRIN_BLUE_MAP_LAYER_NAME,
                disabled: !canUseZenrinMap,
                description:
                  "住居表示と公図に基づく地番を重ね合わせて表示したゼンリンの地図です。",
                minZoom: ZENRIN_BLUE_MAP_MIN_ZOOM,
                maxZoom: ZENRIN_BLUE_MAP_MAX_ZOOM,
                attributionText: "ZENRIN",
                attributionUrl: "https://www.zenrin.co.jp/",
              },
            ],
          },
        ]
      : []),
    // GEOSPACEセクション（権限がある場合のみ表示）
    ...(showGeospaceSection
      ? [
          {
            title: GEOSPACE_SECTION_TITLE,
            layers: [
              {
                name: GEOSPACE_ELECTRONIC_MAP_LAYER_NAME,
                label: "cds地図",
                disabled: !cdsMap || !mapServiceAppId,
                description:
                  "NTTインフラネットが提供する高精度な背景地図（cds地図）です。",
                minZoom: 7, // cds地図の最小ズーム制限は LeafletMap の構成に合わせるためそのまま固定値
                maxZoom: 21,
                attributionText: "NTTインフラネット",
                attributionUrl: "https://geospace.nttinf.co.jp/",
              },
              {
                name: GEOSPACE_CHIBAN_TILE_LAYER_NAME,
                label: "地番地図",
                disabled: !mapServiceAppId,
                description:
                  "NTTインフラネットが提供する全国の地番地図データです。",
                minZoom: GEOSPACE_CHIBAN_PANEL_MIN_ZOOM,
                maxZoom: 22,
                attributionText: "NTTインフラネット",
                attributionUrl: "https://geospace.nttinf.co.jp/",
              },
              {
                name: LEGAL_AFFAIRS_CHIBAN_TILE_LAYER_NAME,
                label: "法務省地番地図",
                disabled: !mapServiceAppId,
                description:
                  "法務省が公開している登記所備付地図データから作成された地番地図です。",
                minZoom: LEGAL_AFFAIRS_CHIBAN_MIN_ZOOM,
                maxZoom: LEGAL_AFFAIRS_CHIBAN_MAX_ZOOM,
                attributionText: "NTTインフラネット",
                attributionUrl: "https://geospace.nttinf.co.jp/",
              },
            ],
          },
        ]
      : []),
    // 役所地番地図セクション（フィーチャーフラグ ON 時のみ表示）。
    // 暫定: 地番地図・登記所備付地図の利用可否はテナント別の isMunicipalParcelMapAvailable でゲートし、
    // 非対象テナントはチェックボックスを disabled にしてお問い合わせ導線を表示する
    // （いずれゼンリン同様の契約プラン設計へ移行予定）。
    ...(trustartChibanMap || registrationMapAvailable
      ? [
          {
            title: TRUSTART_SECTION_TITLE,
            layers: [
              ...(trustartChibanMap
                ? [
                    {
                      name: TRUSTART_CHIBAN_LAYER_NAME,
                      label: "地番地図",
                      description: isMunicipalParcelMapAvailable
                        ? "一部のエリアのみ表示可能です"
                        : "ご契約中のお客様がご利用いただけます",
                      disabled: !isMunicipalParcelMapAvailable,
                      minZoom: TRUSTART_CHIBAN_PANEL_MIN_ZOOM,
                      maxZoom: 22,
                      // 非対象テナントはロック表示（ズーム/出典は出さず、お問い合わせCTAのみ）
                      locked: !isMunicipalParcelMapAvailable,
                      lockedActionUrl: isMunicipalParcelMapAvailable
                        ? undefined
                        : CONTACT_US_URL,
                      lockedActionText: "ご利用のお問い合わせ",
                      // 出典は契約時（利用可）のみ表示する
                      ...(isMunicipalParcelMapAvailable
                        ? {
                            attributionText: "こちらをご確認ください",
                            attributionUrl:
                              "https://trustart.notion.site/3c114754f2df80a0b4eef64dd18440cd",
                            attributionLinkText: "こちら",
                          }
                        : {}),
                    },
                  ]
                : []),
              ...(registrationMapAvailable
                ? [
                    {
                      name: REGISTRATION_MAP_LAYER_NAME,
                      label: REGISTRATION_MAP_LAYER_NAME,
                      description: isMunicipalParcelMapAvailable
                        ? "登記所備付地図データを表示します。"
                        : "ご契約中のお客様がご利用いただけます",
                      disabled: !isMunicipalParcelMapAvailable,
                      minZoom: REGISTRATION_MAP_PANEL_MIN_ZOOM,
                      maxZoom: 22,
                      // 地番地図と同じく、非対象テナントはロック表示（お問い合わせCTAのみ）
                      locked: !isMunicipalParcelMapAvailable,
                      lockedActionUrl: isMunicipalParcelMapAvailable
                        ? undefined
                        : CONTACT_US_URL,
                      lockedActionText: "ご利用のお問い合わせ",
                      ...(isMunicipalParcelMapAvailable
                        ? {
                            attributionText: REGISTRATION_MAP_SOURCE_TEXT,
                            attributionUrl: REGISTRATION_MAP_SOURCE_URL,
                            attributionLinkText:
                              REGISTRATION_MAP_SOURCE_LINK_TEXT,
                          }
                        : {}),
                    },
                  ]
                : []),
            ],
          },
        ]
      : []),
    // 写真（航空写真・衛星画像などのラスタ画像）。構成は photoOverlayGroup.ts を参照
    buildPhotoOverlayGroup(),
    // 物件情報（システム上で検索・取得した情報、ユーザーが保存したプロット）
    {
      title: PROPERTY_INFO_SECTION_TITLE,
      layers: [
        {
          name: REAL_ESTATE_SEARCH_LAYER_NAME,
          label: "不動産検索結果",
          description:
            "システム上で検索した不動産情報を紫のピンで表示します。ピンを開くと物件リストに入り、青のピンに変わります。",
          minZoom: 7, // 7 ~ 22の場合は全てのズームレベルで表示と出てきます
          maxZoom: 22,
        },
        {
          name: SAVED_PLOT_LAYER_NAME,
          label: "保存した物件リスト",
          description: savedPlotColorsByList
            ? "ユーザーが保存した物件プロット（登録情報など）をピンで表示します。1つ目のリストは緑、2つ目以降はリストごとに別の色です。物件リストに入った物件は青のピンに変わります。"
            : "ユーザーが保存した物件プロット（登録情報など）を緑のピンで表示します。物件リストに入った物件は青のピンに変わります。",
          minZoom: 7, // 7 ~ 22の場合は全てのズームレベルで表示と出てきます
          maxZoom: 22,
        },
        {
          name: REQUESTED_PICTURES_PLOT_LAYER_NAME,
          label: "解析済み登記情報",
          description:
            "解析が完了した登記簿情報を赤のピンで表示します。物件リストに入った物件は青のピンに変わります。",
          minZoom: 14, // 実環境のzoomレベル値を反映
          maxZoom: 21,
        },
        // 受付帳情報ピンは受付帳の投影を行った時のみ項目自体を表示する
        ...(hasReceptionBookMarkers
          ? [
              {
                name: RECEPTION_BOOK_LAYER_NAME,
                label: "受付帳情報ピン",
                description:
                  "受付帳データからマッピングした情報をオレンジのピンで表示します。ピンを開くと物件リストに入り、青のピンに変わります。",
                minZoom: 7,
                maxZoom: 22,
              },
            ]
          : []),
      ],
    },
    // 役所資料（黒塗り）。R.E.ASSIST のリユース資料（購入できる物件のピン）
    ...(reassistArchive
      ? [
          {
            title: MUNICIPAL_DOCUMENT_SECTION_TITLE,
            layers: [
              {
                name: MUNICIPAL_DOCUMENT_LAYER_NAME,
                label: "役所資料（黒塗り）",
                description:
                  "リユース資料（黒塗り）がある物件のピンを表示します。ピンを押すと、資料を購入してダウンロードできます。",
                minZoom: 7,
                maxZoom: 22,
              },
            ],
          },
        ]
      : []),
    // 価格情報
    {
      title: PRICE_INFO_SECTION_TITLE,
      layers: [
        {
          name: LAND_PRICE_LAYER_NAME,
          label: "公示価格",
          description:
            "地価公示および地価調査に基づく基準地の価格情報を表示します。",
          minZoom: LAND_PRICE_MIN_ZOOM + 1, // maplibreとのズームレベル値のズレのため+1
          maxZoom: LAND_PRICE_MAX_ZOOM,
          attributionText: "国土数値情報",
          attributionUrl: "https://nlftp.mlit.go.jp/ksj/index.html",
        },
        {
          name: TRADE_PRICE_LAYER_NAME,
          label: "取引価格",
          description:
            "国土交通省が公開している不動産の実際の取引実績価格情報を表示します。",
          minZoom: TRADE_PRICE_MIN_ZOOM + 1, // maplibreとのズームレベル値のズレのため+1
          maxZoom: TRADE_PRICE_MAX_ZOOM,
          attributionText: "不動産情報ライブラリ",
          attributionUrl: "https://www.reinfolib.mlit.go.jp/",
        },
      ],
    },
    // 交通
    ...(isRoadLayerEnabled
      ? [
          {
            title: TRAFFIC_INFO_SECTION_TITLE,
            layers: [
              {
                type: "choice",
                name: ROAD_LAYER_NAME,
                label: ROAD_LAYER_NAME,
                disabled: !ROAD_TILE_HOST,
                minZoom: 16,
                maxZoom: 22,
                attributionText: "国土数値情報",
                attributionUrl: "https://nlftp.mlit.go.jp/ksj/index.html",
                description: "道路分類種別と幅員区分の表示を切り替えます。",
                choices: [
                  { label: "道路分類種別", value: ROAD_LAYER_MODE_CLASS },
                  { label: "幅員区分", value: ROAD_LAYER_MODE_WIDTH },
                ],
              },
            ],
          } satisfies OverlayGroup,
        ]
      : []),
    // 都市計画情報
    {
      title: CITY_PLANNING_INFO_SECTION_TITLE,
      layers: [
        {
          name: CITY_PLANNING_AREA_LAYER_NAME,
          label: "都市計画区域",
          description:
            "都市計画法に基づき指定された都市計画区域の境界を表示します。",
          minZoom: CITY_PLANNING_AREA_MIN_ZOOM,
          maxZoom: CITY_PLANNING_AREA_MAX_ZOOM,
          attributionText: "国土数値情報",
          attributionUrl: "https://nlftp.mlit.go.jp/ksj/index.html",
        },
        {
          name: AREA_USE_PURPOSE_LAYER_NAME_NATIONAL_LAND_NUMERICAL_INFORMATION,
          label: "用途地域（国土数値情報）",
          disabled: !NATIONAL_LAND_NUMERICAL_INFORMATION_HOST,
          description: "国土数値情報に基づく用途地域指定エリアを表示します。",
          minZoom: AREA_USE_PURPOSE_MIN_ZOOM + 1,
          maxZoom: AREA_USE_PURPOSE_MAX_ZOOM,
          attributionText: "国土数値情報",
          attributionUrl: "https://nlftp.mlit.go.jp/ksj/index.html",
        },
        ...(cityPlanningAreaUsePurposeLayer
          ? [
              {
                name: AREA_USE_PURPOSE_LAYER_NAME_CITY_PLANNING_DECISION_GIS_DATA,
                label: "用途地域（都市計画決定GIS）",
                disabled: !CITY_PLANNING_DECISION_GIS_DATA_HOST,
                description:
                  "都市計画決定GISデータに基づくより詳細な用途地域エリアを表示します。",
                minZoom: AREA_USE_PURPOSE_MIN_ZOOM + 1,
                maxZoom: AREA_USE_PURPOSE_MAX_ZOOM,
                attributionText: "都市計画決定GISデータ",
                attributionUrl:
                  "https://www.mlit.go.jp/toshi/tosiko/toshi_tosiko_tk_000087.html",
              },
            ]
          : []),
        {
          name: FIRE_PROTECTION_AREA_LAYER_NAME,
          label: "防火・準防火地域",
          description:
            "建築基準法に基づき指定された防火地域および準防火地域を表示します。",
          minZoom: FIRE_PROTECTION_POLYGON_MIN_ZOOM,
          maxZoom: FIRE_PROTECTION_POLYGON_MAX_ZOOM,
          attributionText: "国土数値情報",
          attributionUrl: "https://nlftp.mlit.go.jp/ksj/index.html",
        },
        {
          name: HIGH_LEVEL_AREA_LAYER_NAME,
          label: "高度地区",
          description: "高度地区を表示します。",
          minZoom: HIGH_LEVEL_AREA_MIN_ZOOM,
          maxZoom: HIGH_LEVEL_AREA_MAX_ZOOM,
          attributionText: "国土数値情報",
          attributionUrl: "https://nlftp.mlit.go.jp/ksj/index.html",
        },
        {
          name: HIGH_LEVEL_USE_AREA_LAYER_NAME,
          label: "高度利用地区",
          description: "高度利用地区を表示します。",
          minZoom: HIGH_LEVEL_USE_AREA_MIN_ZOOM,
          maxZoom: HIGH_LEVEL_USE_AREA_MAX_ZOOM,
          attributionText: "国土数値情報",
          attributionUrl: "https://nlftp.mlit.go.jp/ksj/index.html",
        },
      ],
    },
    // 防災・ハザード情報
    {
      title: DISASTER_HAZARD_INFO_SECTION_TITLE,
      layers: [
        {
          type: "year", // この値が"year"の場合、年度指定UIが表示されます
          name: FLOOD_10_LAYER_NAME,
          label: FLOOD_10_LAYER_NAME,
          years: [2024, 2023], // このyears配列の順番でラジオボタンが表示されます
          description: "計画とする降雨規模による洪水浸水想定区域を表示します。",
          minZoom: HAZARD_BASE_MIN_ZOOM + 1,
          maxZoom: HAZARD_BASE_MAX_ZOOM,
          attributionText: "国土数値情報",
          attributionUrl: "https://nlftp.mlit.go.jp/ksj/index.html",
        },
        {
          type: "year",
          name: FLOOD_20_LAYER_NAME,
          label: "洪水浸水想定区域（想定最大）",
          years: [2024, 2023],
          description:
            "想定し得る最大規模の降雨による洪水浸水想定区域を表示します。",
          minZoom: HAZARD_BASE_MIN_ZOOM + 1,
          maxZoom: HAZARD_BASE_MAX_ZOOM,
          attributionText: "国土数値情報",
          attributionUrl: "https://nlftp.mlit.go.jp/ksj/index.html",
        },
        {
          type: "year",
          name: FLOOD_30_LAYER_NAME,
          label: FLOOD_30_LAYER_NAME,
          years: [2024, 2023],
          description:
            "洪水時の浸水が一定時間以上継続するおそれがある区域を表示します。",
          minZoom: HAZARD_BASE_MIN_ZOOM + 1,
          maxZoom: HAZARD_BASE_MAX_ZOOM,
          attributionText: "国土数値情報",
          attributionUrl: "https://nlftp.mlit.go.jp/ksj/index.html",
        },
        {
          name: TSUNAMI_LAYER_NAME,
          label: TSUNAMI_LAYER_NAME,
          description:
            "津波防災地域づくりに関する法律に基づき指定された津波浸水想定区域を表示します。",
          minZoom: HAZARD_BASE_MIN_ZOOM + 1,
          maxZoom: HAZARD_BASE_MAX_ZOOM,
          attributionText: "国土数値情報",
          attributionUrl: "https://nlftp.mlit.go.jp/ksj/index.html",
        },
        {
          name: STORM_SURGE_LAYER_NAME,
          label: STORM_SURGE_LAYER_NAME,
          description:
            "想定し得る最大規模の高潮による浸水想定区域を表示します。",
          minZoom: HAZARD_BASE_MIN_ZOOM + 1,
          maxZoom: HAZARD_BASE_MAX_ZOOM,
          attributionText: "国土数値情報",
          attributionUrl: "https://nlftp.mlit.go.jp/ksj/index.html",
        },
        {
          type: "year",
          name: LANDSLIDE_STEEP_SLOPE_LAYER_NAME,
          label: LANDSLIDE_STEEP_SLOPE_LAYER_NAME,
          years: [2025, 2024],
          description:
            "急傾斜地の崩壊（がけ崩れ）による土砂災害警戒区域を表示します。",
          minZoom: HAZARD_BASE_MIN_ZOOM + 1,
          maxZoom: HAZARD_BASE_MAX_ZOOM,
          attributionText: "国土数値情報",
          attributionUrl: "https://nlftp.mlit.go.jp/ksj/index.html",
        },
        {
          type: "year",
          name: LANDSLIDE_DEBRIS_FLOW_LAYER_NAME,
          label: LANDSLIDE_DEBRIS_FLOW_LAYER_NAME,
          years: [2025, 2024],
          description: "土石流による土砂災害警戒区域を表示します。",
          minZoom: HAZARD_BASE_MIN_ZOOM + 1,
          maxZoom: HAZARD_BASE_MAX_ZOOM,
          attributionText: "国土数値情報",
          attributionUrl: "https://nlftp.mlit.go.jp/ksj/index.html",
        },
        {
          type: "year",
          name: LANDSLIDE_LANDSLIDE_LAYER_NAME,
          label: LANDSLIDE_LANDSLIDE_LAYER_NAME,
          years: [2025, 2024],
          description: "地すべりによる土砂災害警戒区域を表示します。",
          minZoom: HAZARD_BASE_MIN_ZOOM + 1,
          maxZoom: HAZARD_BASE_MAX_ZOOM,
          attributionText: "国土数値情報",
          attributionUrl: "https://nlftp.mlit.go.jp/ksj/index.html",
        },
        {
          type: "year",
          name: LANDSLIDE_PREVENTION_LAYER_NAME,
          label: "地すべり防止地区",
          years: [2021, 2020],
          description:
            "地すべり防止法に基づき指定された地すべり防止地区の境界を表示します。",
          minZoom: LANDSLIDE_PREVENTION_MIN_ZOOM + 1,
          maxZoom: LANDSLIDE_PREVENTION_MAX_ZOOM,
          attributionText: "国土数値情報",
          attributionUrl: "https://nlftp.mlit.go.jp/ksj/index.html",
        },
        {
          name: DISASTER_RISK_AREA_LAYER_NAME,
          label: "災害危険区域",
          description:
            "地方自治体の条例に基づき災害の危険性が高いと指定された区域を表示します。",
          minZoom: DISASTER_RISK_AREA_MIN_ZOOM + 1,
          maxZoom: DISASTER_RISK_AREA_MAX_ZOOM,
          attributionText: "国土数値情報",
          attributionUrl: "https://nlftp.mlit.go.jp/ksj/index.html",
        },
      ],
    },
    // 周辺施設情報
    {
      title: SURROUNDING_FACILITY_INFO_SECTION_TITLE,
      layers: [
        {
          type: "year",
          name: ELEMENTARY_SCHOOL_AREA_LAYER_NAME,
          label: ELEMENTARY_SCHOOL_AREA_LAYER_NAME,
          years: [2023, 2021, 2016, 2010],
          // 年度の選択肢が多く1行に収まらないため、2行に折り返す幅で固定する
          maxWidth: 210,
          description: "公立小学校の通学区域を表示します。",
          minZoom: SCHOOL_AREA_MIN_ZOOM,
          maxZoom: SCHOOL_AREA_MAX_ZOOM,
          attributionText: "国土数値情報",
          attributionUrl: "https://nlftp.mlit.go.jp/ksj/index.html",
        },
        {
          type: "year",
          name: JUNIOR_HIGH_SCHOOL_AREA_LAYER_NAME,
          label: JUNIOR_HIGH_SCHOOL_AREA_LAYER_NAME,
          years: [2023, 2021, 2016],
          maxWidth: 210,
          description: "公立中学校の通学区域を表示します。",
          minZoom: SCHOOL_AREA_MIN_ZOOM,
          maxZoom: SCHOOL_AREA_MAX_ZOOM,
          attributionText: "国土数値情報",
          attributionUrl: "https://nlftp.mlit.go.jp/ksj/index.html",
        },
        ...(idolFarmland
          ? [
              {
                name: IDOL_FARMLAND_LAYER_NAME,
                label: "遊休農地",
                description: "遊休農地（耕作放棄地など）の位置を表示します。",
                minZoom: IDOL_FARMLAND_MIN_ZOOM,
                maxZoom: IDOL_FARMLAND_MAX_ZOOM,
              },
            ]
          : []),
        ...(farmland
          ? [
              {
                name: FARMLAND_LAYER_NAME,
                label: FARMLAND_LAYER_LABEL,
                description: "農地情報を表示します。",
                minZoom: FARMLAND_MIN_ZOOM,
                maxZoom: FARMLAND_MAX_ZOOM,
                action: farmlandAction,
              },
            ]
          : []),
      ],
    },
  ];
};
